var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.438 6.95c-4.263-4.262-11.213-4.262-15.475 0a10.86 10.86 0 0 0-3.213 7.738c0 2.925 1.138 5.675 3.213 7.737a10.9 10.9 0 0 0 7.737 3.2c2.8 0 5.6-1.062 7.738-3.2 4.262-4.262 4.262-11.212 0-15.475M14.7 23.725c-4.975 0-9.037-4.05-9.037-9.037s4.05-9.025 9.037-9.025 9.038 4.05 9.038 9.037-4.05 9.038-9.038 9.038z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.888 10.375c-.638-.375-1.438.088-1.438.838v6.975c0 .737.8 1.2 1.438.837l6.037-3.487c.638-.375.638-1.3 0-1.663l-6.037-3.487z"
  }))));
};
export default SvgPlay;